import { z } from 'zod';

export const nonNegative = () =>
  z.coerce
    .number({ message: 'Must be a number' })

    /**
     * Enforce non negative number
     */
    .min(0, { message: 'Must be a non-negative number' });
